import React, { useState, useEffect } from 'react';
import { getStats } from '../../api/adminApi';
import LoadingData from '../../components/LoadingData';
import { theme } from '../../adminTheme';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getStats();
        setStats(res.data);
      } catch { setError('Error al cargar estadísticas'); }
      finally { setLoading(false); }
    };
    fetch();
  }, []);

  if (loading) return <LoadingData />;
  if (error) return <p style={{ color: theme.error, padding: 20 }}>{error}</p>;
  if (!stats) return null;

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Dashboard</h1>
      <div style={styles.grid}>
        <StatCard title="Usuarios" value={stats.users.total} />
        <StatCard title="Bots" value={stats.bots.total} subtitle={`${stats.bots.active} activos`} />
        <StatCard title="Facturas" value={stats.invoices.total} subtitle={`${stats.invoices.paid} pagadas / ${stats.invoices.pending} pendientes`} />
        <StatCard title="Facturación" value={`$${(stats.invoices.total_fee || 0).toFixed(2)}`} subtitle={`Cobrado: $${(stats.invoices.total_paid || 0).toFixed(2)} | Pendiente: $${(stats.invoices.total_pending || 0).toFixed(2)}`} />
        <StatCard title="Usuarios con Deuda" value={stats.invoices.users_with_debt} subtitle="tienen facturas impagas" />
      </div>
    </div>
  );
}

function StatCard({ title, value, subtitle }) {
  return (
    <div style={styles.card}>
      <h3 style={styles.cardTitle}>{title}</h3>
      <p style={styles.cardValue}>{value}</p>
      {subtitle && <p style={styles.cardSub}>{subtitle}</p>}
    </div>
  );
}

const styles = {
  container: { padding: '24px', minHeight: '100vh' },
  title: { margin: '0 0 24px 0', fontSize: '1.5rem', color: theme.text },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '16px' },
  card: { backgroundColor: theme.card, padding: '20px', borderRadius: '8px', border: `1px solid ${theme.border}` },
  cardTitle: { margin: '0 0 8px 0', fontSize: '0.9rem', color: theme.textMuted, fontWeight: 400 },
  cardValue: { fontSize: '2rem', fontWeight: 700, margin: '0 0 4px 0', color: theme.text },
  cardSub: { fontSize: '0.85rem', color: theme.textMuted, margin: 0 },
};
